export type MatrixStatus='included'|'excluded'|'limit'|'n/a';
export type AuditCell={status:MatrixStatus;limit?:number|null;assumption?:boolean;inheritance?:boolean};
export type AuditFunction={id:string;label:string;moduleId:string;defaults:Record<string,AuditCell>};
export type AuditModule={id:string;title:string;functions:AuditFunction[]};
export const AUDIT_FUNCTIONS: AuditFunction[] = [
  {
    "id": "F1",
    "label": "Create New Condo",
    "moduleId": "platform-admin",
    "defaults": {
      "free": {
        "status": "n/a"
      },
      "paid_home": {
        "status": "n/a"
      },
      "free_condo": {
        "status": "n/a"
      },
      "paid_condo": {
        "status": "n/a"
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F2",
    "label": "Edit Condo Settings",
    "moduleId": "platform-admin",
    "defaults": {
      "free": {
        "status": "n/a"
      },
      "paid_home": {
        "status": "n/a"
      },
      "free_condo": {
        "status": "n/a"
      },
      "paid_condo": {
        "status": "n/a"
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F3",
    "label": "Delete/Deactivate Condo",
    "moduleId": "platform-admin",
    "defaults": {
      "free": {
        "status": "n/a"
      },
      "paid_home": {
        "status": "n/a"
      },
      "free_condo": {
        "status": "n/a"
      },
      "paid_condo": {
        "status": "n/a"
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F4",
    "label": "View All Condos",
    "moduleId": "platform-admin",
    "defaults": {
      "free": {
        "status": "n/a"
      },
      "paid_home": {
        "status": "n/a"
      },
      "free_condo": {
        "status": "n/a"
      },
      "paid_condo": {
        "status": "n/a"
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F5",
    "label": "Assign Admin to Condo",
    "moduleId": "platform-admin",
    "defaults": {
      "free": {
        "status": "n/a"
      },
      "paid_home": {
        "status": "n/a"
      },
      "free_condo": {
        "status": "n/a"
      },
      "paid_condo": {
        "status": "n/a"
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F6",
    "label": "Set Condo Pricing Plan",
    "moduleId": "platform-admin",
    "defaults": {
      "free": {
        "status": "n/a"
      },
      "paid_home": {
        "status": "n/a"
      },
      "free_condo": {
        "status": "n/a"
      },
      "paid_condo": {
        "status": "n/a"
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F7",
    "label": "View Global Analytics",
    "moduleId": "platform-admin",
    "defaults": {
      "free": {
        "status": "n/a"
      },
      "paid_home": {
        "status": "n/a"
      },
      "free_condo": {
        "status": "n/a"
      },
      "paid_condo": {
        "status": "n/a"
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F8",
    "label": "Platform User Management",
    "moduleId": "platform-admin",
    "defaults": {
      "free": {
        "status": "n/a"
      },
      "paid_home": {
        "status": "n/a"
      },
      "free_condo": {
        "status": "n/a"
      },
      "paid_condo": {
        "status": "n/a"
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F9",
    "label": "Dashboard Principal",
    "moduleId": "dashboard",
    "defaults": {
      "free": {
        "status": "n/a"
      },
      "paid_home": {
        "status": "n/a"
      },
      "free_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F10",
    "label": "View Charts/Analytics (Condo)",
    "moduleId": "dashboard",
    "defaults": {
      "free": {
        "status": "n/a"
      },
      "paid_home": {
        "status": "n/a"
      },
      "free_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F11",
    "label": "Create Resident Account",
    "moduleId": "residents",
    "defaults": {
      "free": {
        "status": "n/a"
      },
      "paid_home": {
        "status": "n/a"
      },
      "free_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F12",
    "label": "Create Propietario Account",
    "moduleId": "residents",
    "defaults": {
      "free": {
        "status": "n/a"
      },
      "paid_home": {
        "status": "n/a"
      },
      "free_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F13",
    "label": "Create Inquilino Account",
    "moduleId": "residents",
    "defaults": {
      "free": {
        "status": "n/a"
      },
      "paid_home": {
        "status": "n/a"
      },
      "free_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F14",
    "label": "Create Empleado Account",
    "moduleId": "residents",
    "defaults": {
      "free": {
        "status": "n/a"
      },
      "paid_home": {
        "status": "n/a"
      },
      "free_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F15",
    "label": "Edit Resident Data",
    "moduleId": "residents",
    "defaults": {
      "free": {
        "status": "n/a"
      },
      "paid_home": {
        "status": "n/a"
      },
      "free_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F16",
    "label": "Suspend Resident",
    "moduleId": "residents",
    "defaults": {
      "free": {
        "status": "n/a"
      },
      "paid_home": {
        "status": "n/a"
      },
      "free_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F17",
    "label": "Delete Resident",
    "moduleId": "residents",
    "defaults": {
      "free": {
        "status": "n/a"
      },
      "paid_home": {
        "status": "n/a"
      },
      "free_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F18",
    "label": "View Resident List",
    "moduleId": "residents",
    "defaults": {
      "free": {
        "status": "n/a"
      },
      "paid_home": {
        "status": "n/a"
      },
      "free_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F19",
    "label": "Export Resident Data",
    "moduleId": "residents",
    "defaults": {
      "free": {
        "status": "n/a"
      },
      "paid_home": {
        "status": "n/a"
      },
      "free_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F20",
    "label": "View Condo Financial Summary",
    "moduleId": "finances",
    "defaults": {
      "free": {
        "status": "included",
        "assumption": true,
        "inheritance": false
      },
      "paid_home": {
        "status": "included",
        "assumption": true,
        "inheritance": false
      },
      "free_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F21",
    "label": "View Personal Account",
    "moduleId": "finances",
    "defaults": {
      "free": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_home": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F22",
    "label": "View Resident Account (Admin)",
    "moduleId": "finances",
    "defaults": {
      "free": {
        "status": "n/a"
      },
      "paid_home": {
        "status": "n/a"
      },
      "free_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F23",
    "label": "Monthly Close / Reports",
    "moduleId": "finances",
    "defaults": {
      "free": {
        "status": "n/a"
      },
      "paid_home": {
        "status": "n/a"
      },
      "free_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F24",
    "label": "Add Income Entry",
    "moduleId": "finances",
    "defaults": {
      "free": {
        "status": "n/a"
      },
      "paid_home": {
        "status": "n/a"
      },
      "free_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F25",
    "label": "View All Income",
    "moduleId": "finances",
    "defaults": {
      "free": {
        "status": "n/a"
      },
      "paid_home": {
        "status": "n/a"
      },
      "free_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F26",
    "label": "Create Income Categories",
    "moduleId": "finances",
    "defaults": {
      "free": {
        "status": "n/a"
      },
      "paid_home": {
        "status": "n/a"
      },
      "free_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F27",
    "label": "Add Expense Entry",
    "moduleId": "finances",
    "defaults": {
      "free": {
        "status": "n/a"
      },
      "paid_home": {
        "status": "n/a"
      },
      "free_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F28",
    "label": "View All Expenses",
    "moduleId": "finances",
    "defaults": {
      "free": {
        "status": "n/a"
      },
      "paid_home": {
        "status": "n/a"
      },
      "free_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F29",
    "label": "Create Expense Categories",
    "moduleId": "finances",
    "defaults": {
      "free": {
        "status": "n/a"
      },
      "paid_home": {
        "status": "n/a"
      },
      "free_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F30",
    "label": "Upload Expense Receipt",
    "moduleId": "finances",
    "defaults": {
      "free": {
        "status": "n/a"
      },
      "paid_home": {
        "status": "n/a"
      },
      "free_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F31",
    "label": "Approve Expenses (> threshold)",
    "moduleId": "finances",
    "defaults": {
      "free": {
        "status": "n/a"
      },
      "paid_home": {
        "status": "n/a"
      },
      "free_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F32",
    "label": "View Pending Approvals",
    "moduleId": "finances",
    "defaults": {
      "free": {
        "status": "n/a"
      },
      "paid_home": {
        "status": "n/a"
      },
      "free_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F33",
    "label": "Create Project",
    "moduleId": "quotes",
    "defaults": {
      "free": {
        "status": "n/a"
      },
      "paid_home": {
        "status": "n/a"
      },
      "free_condo": {
        "status": "excluded",
        "assumption": true,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": true,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F34",
    "label": "Add Quote (min 3)",
    "moduleId": "quotes",
    "defaults": {
      "free": {
        "status": "n/a"
      },
      "paid_home": {
        "status": "n/a"
      },
      "free_condo": {
        "status": "excluded",
        "assumption": true,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": true,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F35",
    "label": "Approve Project / Quote",
    "moduleId": "quotes",
    "defaults": {
      "free": {
        "status": "n/a"
      },
      "paid_home": {
        "status": "n/a"
      },
      "free_condo": {
        "status": "excluded",
        "assumption": true,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": true,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F36",
    "label": "View Project Status",
    "moduleId": "quotes",
    "defaults": {
      "free": {
        "status": "n/a"
      },
      "paid_home": {
        "status": "n/a"
      },
      "free_condo": {
        "status": "excluded",
        "assumption": true,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": true,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F37",
    "label": "Make Payment (Resident)",
    "moduleId": "payments",
    "defaults": {
      "free": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_home": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F38",
    "label": "View Payment History",
    "moduleId": "payments",
    "defaults": {
      "free": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_home": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F39",
    "label": "Record Manual Payment",
    "moduleId": "payments",
    "defaults": {
      "free": {
        "status": "n/a"
      },
      "paid_home": {
        "status": "n/a"
      },
      "free_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F40",
    "label": "Generate Payment Reports",
    "moduleId": "payments",
    "defaults": {
      "free": {
        "status": "n/a"
      },
      "paid_home": {
        "status": "n/a"
      },
      "free_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F41",
    "label": "View Morosos List",
    "moduleId": "morosos",
    "defaults": {
      "free": {
        "status": "n/a"
      },
      "paid_home": {
        "status": "n/a"
      },
      "free_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F42",
    "label": "Configure Morosidad Rules",
    "moduleId": "morosos",
    "defaults": {
      "free": {
        "status": "n/a"
      },
      "paid_home": {
        "status": "n/a"
      },
      "free_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F43",
    "label": "Send Moroso Notifications",
    "moduleId": "morosos",
    "defaults": {
      "free": {
        "status": "n/a"
      },
      "paid_home": {
        "status": "n/a"
      },
      "free_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F44",
    "label": "Create/Edit Amenities",
    "moduleId": "amenities",
    "defaults": {
      "free": {
        "status": "n/a"
      },
      "paid_home": {
        "status": "n/a"
      },
      "free_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F45",
    "label": "Set Amenity Pricing",
    "moduleId": "amenities",
    "defaults": {
      "free": {
        "status": "n/a"
      },
      "paid_home": {
        "status": "n/a"
      },
      "free_condo": {
        "status": "included",
        "assumption": true,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F46",
    "label": "Create Reservation",
    "moduleId": "amenities",
    "defaults": {
      "free": {
        "status": "excluded",
        "assumption": false,
        "inheritance": false
      },
      "paid_home": {
        "status": "excluded",
        "assumption": false,
        "inheritance": false
      },
      "free_condo": {
        "status": "excluded",
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F47",
    "label": "Approve Reservation",
    "moduleId": "amenities",
    "defaults": {
      "free": {
        "status": "n/a"
      },
      "paid_home": {
        "status": "n/a"
      },
      "free_condo": {
        "status": "excluded",
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F48",
    "label": "View All Reservations",
    "moduleId": "amenities",
    "defaults": {
      "free": {
        "status": "n/a"
      },
      "paid_home": {
        "status": "n/a"
      },
      "free_condo": {
        "status": "excluded",
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F49",
    "label": "Cancel Reservation",
    "moduleId": "amenities",
    "defaults": {
      "free": {
        "status": "excluded",
        "assumption": false,
        "inheritance": false
      },
      "paid_home": {
        "status": "excluded",
        "assumption": false,
        "inheritance": false
      },
      "free_condo": {
        "status": "excluded",
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F50",
    "label": "Create Event",
    "moduleId": "calendar",
    "defaults": {
      "free": {
        "status": "limit",
        "limit": 5,
        "assumption": false,
        "inheritance": false
      },
      "paid_home": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_condo": {
        "status": "limit",
        "limit": 5,
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F51",
    "label": "Edit Event",
    "moduleId": "calendar",
    "defaults": {
      "free": {
        "status": "limit",
        "limit": 5,
        "assumption": false,
        "inheritance": false
      },
      "paid_home": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_condo": {
        "status": "limit",
        "limit": 5,
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F52",
    "label": "Delete Event",
    "moduleId": "calendar",
    "defaults": {
      "free": {
        "status": "limit",
        "limit": 5,
        "assumption": false,
        "inheritance": false
      },
      "paid_home": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_condo": {
        "status": "limit",
        "limit": 5,
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F53",
    "label": "View Events",
    "moduleId": "calendar",
    "defaults": {
      "free": {
        "status": "limit",
        "limit": 5,
        "assumption": false,
        "inheritance": false
      },
      "paid_home": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_condo": {
        "status": "limit",
        "limit": 5,
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F54",
    "label": "RSVP to Event",
    "moduleId": "calendar",
    "defaults": {
      "free": {
        "status": "limit",
        "limit": 5,
        "assumption": false,
        "inheritance": false
      },
      "paid_home": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_condo": {
        "status": "limit",
        "limit": 5,
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F55",
    "label": "Submit Complaint",
    "moduleId": "complaints",
    "defaults": {
      "free": {
        "status": "limit",
        "limit": 5,
        "assumption": false,
        "inheritance": false
      },
      "paid_home": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_condo": {
        "status": "limit",
        "limit": 5,
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F56",
    "label": "View All Complaints",
    "moduleId": "complaints",
    "defaults": {
      "free": {
        "status": "limit",
        "limit": 5,
        "assumption": false,
        "inheritance": false
      },
      "paid_home": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_condo": {
        "status": "limit",
        "limit": 5,
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F57",
    "label": "Respond to Complaint",
    "moduleId": "complaints",
    "defaults": {
      "free": {
        "status": "limit",
        "limit": 5,
        "assumption": false,
        "inheritance": false
      },
      "paid_home": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_condo": {
        "status": "limit",
        "limit": 5,
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F58",
    "label": "Marcar como resuelta",
    "moduleId": "complaints",
    "defaults": {
      "free": {
        "status": "limit",
        "limit": 5,
        "assumption": false,
        "inheritance": false
      },
      "paid_home": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_condo": {
        "status": "limit",
        "limit": 5,
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F59",
    "label": "Create Announcement",
    "moduleId": "announcements",
    "defaults": {
      "free": {
        "status": "n/a"
      },
      "paid_home": {
        "status": "n/a"
      },
      "free_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F60",
    "label": "Edit Announcement",
    "moduleId": "announcements",
    "defaults": {
      "free": {
        "status": "n/a"
      },
      "paid_home": {
        "status": "n/a"
      },
      "free_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F61",
    "label": "Delete Announcement",
    "moduleId": "announcements",
    "defaults": {
      "free": {
        "status": "n/a"
      },
      "paid_home": {
        "status": "n/a"
      },
      "free_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F62",
    "label": "View Announcements",
    "moduleId": "announcements",
    "defaults": {
      "free": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_home": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F63",
    "label": "Create Vote/Poll",
    "moduleId": "voting",
    "defaults": {
      "free": {
        "status": "included",
        "assumption": true,
        "inheritance": false
      },
      "paid_home": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F64",
    "label": "Cast Vote",
    "moduleId": "voting",
    "defaults": {
      "free": {
        "status": "included",
        "assumption": true,
        "inheritance": false
      },
      "paid_home": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F65",
    "label": "View Vote Results",
    "moduleId": "voting",
    "defaults": {
      "free": {
        "status": "included",
        "assumption": true,
        "inheritance": false
      },
      "paid_home": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F66",
    "label": "View Personal QR",
    "moduleId": "qr-access",
    "defaults": {
      "free": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_home": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F67",
    "label": "Generate Guest QR",
    "moduleId": "qr-access",
    "defaults": {
      "free": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_home": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F68",
    "label": "Verify QR (Scan)",
    "moduleId": "qr-access",
    "defaults": {
      "free": {
        "status": "n/a"
      },
      "paid_home": {
        "status": "n/a"
      },
      "free_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F69",
    "label": "Trigger Panic Button",
    "moduleId": "panic",
    "defaults": {
      "free": {
        "status": "excluded",
        "assumption": false,
        "inheritance": false
      },
      "paid_home": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_condo": {
        "status": "excluded",
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F70",
    "label": "View Panic Alerts",
    "moduleId": "panic",
    "defaults": {
      "free": {
        "status": "n/a"
      },
      "paid_home": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_condo": {
        "status": "excluded",
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F71",
    "label": "Respond to Alert",
    "moduleId": "panic",
    "defaults": {
      "free": {
        "status": "n/a"
      },
      "paid_home": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_condo": {
        "status": "excluded",
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F72",
    "label": "Registro de Visitas (Visitor Log module)",
    "moduleId": "security",
    "defaults": {
      "free": {
        "status": "n/a"
      },
      "paid_home": {
        "status": "n/a"
      },
      "free_condo": {
        "status": "excluded",
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F73",
    "label": "Register Visitor Entry",
    "moduleId": "security",
    "defaults": {
      "free": {
        "status": "n/a"
      },
      "paid_home": {
        "status": "n/a"
      },
      "free_condo": {
        "status": "excluded",
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F74",
    "label": "Register Visitor Exit",
    "moduleId": "security",
    "defaults": {
      "free": {
        "status": "n/a"
      },
      "paid_home": {
        "status": "n/a"
      },
      "free_condo": {
        "status": "excluded",
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F75",
    "label": "View Visitor Log",
    "moduleId": "security",
    "defaults": {
      "free": {
        "status": "n/a"
      },
      "paid_home": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_condo": {
        "status": "excluded",
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F76",
    "label": "View Emergency Contacts",
    "moduleId": "security",
    "defaults": {
      "free": {
        "status": "included",
        "assumption": true,
        "inheritance": false
      },
      "paid_home": {
        "status": "included",
        "assumption": true,
        "inheritance": false
      },
      "free_condo": {
        "status": "included",
        "assumption": true,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": true,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F77",
    "label": "Call Emergency Number",
    "moduleId": "security",
    "defaults": {
      "free": {
        "status": "included",
        "assumption": true,
        "inheritance": false
      },
      "paid_home": {
        "status": "included",
        "assumption": true,
        "inheritance": false
      },
      "free_condo": {
        "status": "included",
        "assumption": true,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": true,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F78",
    "label": "Aviso de Viaje (Create)",
    "moduleId": "travel",
    "defaults": {
      "free": {
        "status": "excluded",
        "assumption": false,
        "inheritance": false
      },
      "paid_home": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_condo": {
        "status": "excluded",
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F79",
    "label": "Aviso de Viaje (View)",
    "moduleId": "travel",
    "defaults": {
      "free": {
        "status": "excluded",
        "assumption": false,
        "inheritance": false
      },
      "paid_home": {
        "status": "included",
        "assumption": true,
        "inheritance": false
      },
      "free_condo": {
        "status": "excluded",
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F80",
    "label": "Create Task",
    "moduleId": "home-tasks",
    "defaults": {
      "free": {
        "status": "limit",
        "limit": 5,
        "assumption": false,
        "inheritance": false
      },
      "paid_home": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_condo": {
        "status": "n/a"
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": true
      },
      "free_supplier": {
        "status": "limit",
        "limit": null,
        "assumption": true,
        "inheritance": false
      },
      "paid_supplier": {
        "status": "limit",
        "limit": null,
        "assumption": true,
        "inheritance": false
      }
    }
  },
  {
    "id": "F81",
    "label": "Assign Task",
    "moduleId": "home-tasks",
    "defaults": {
      "free": {
        "status": "limit",
        "limit": 5,
        "assumption": false,
        "inheritance": false
      },
      "paid_home": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_condo": {
        "status": "n/a"
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": true
      },
      "free_supplier": {
        "status": "limit",
        "limit": null,
        "assumption": true,
        "inheritance": false
      },
      "paid_supplier": {
        "status": "limit",
        "limit": null,
        "assumption": true,
        "inheritance": false
      }
    }
  },
  {
    "id": "F82",
    "label": "Complete Task",
    "moduleId": "home-tasks",
    "defaults": {
      "free": {
        "status": "limit",
        "limit": 5,
        "assumption": false,
        "inheritance": false
      },
      "paid_home": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_condo": {
        "status": "n/a"
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": true
      },
      "free_supplier": {
        "status": "limit",
        "limit": null,
        "assumption": true,
        "inheritance": false
      },
      "paid_supplier": {
        "status": "limit",
        "limit": null,
        "assumption": true,
        "inheritance": false
      }
    }
  },
  {
    "id": "F83",
    "label": "View Task List",
    "moduleId": "home-tasks",
    "defaults": {
      "free": {
        "status": "limit",
        "limit": 5,
        "assumption": false,
        "inheritance": false
      },
      "paid_home": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_condo": {
        "status": "n/a"
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": true
      },
      "free_supplier": {
        "status": "limit",
        "limit": null,
        "assumption": true,
        "inheritance": false
      },
      "paid_supplier": {
        "status": "limit",
        "limit": null,
        "assumption": true,
        "inheritance": false
      }
    }
  },
  {
    "id": "F84",
    "label": "Create Shopping List / Item",
    "moduleId": "home-shopping",
    "defaults": {
      "free": {
        "status": "limit",
        "limit": 20,
        "assumption": false,
        "inheritance": false
      },
      "paid_home": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_condo": {
        "status": "n/a"
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": true
      },
      "free_supplier": {
        "status": "limit",
        "limit": null,
        "assumption": true,
        "inheritance": false
      },
      "paid_supplier": {
        "status": "limit",
        "limit": null,
        "assumption": true,
        "inheritance": false
      }
    }
  },
  {
    "id": "F85",
    "label": "Share Shopping List",
    "moduleId": "home-shopping",
    "defaults": {
      "free": {
        "status": "limit",
        "limit": 20,
        "assumption": false,
        "inheritance": false
      },
      "paid_home": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_condo": {
        "status": "n/a"
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": true
      },
      "free_supplier": {
        "status": "limit",
        "limit": null,
        "assumption": true,
        "inheritance": false
      },
      "paid_supplier": {
        "status": "limit",
        "limit": null,
        "assumption": true,
        "inheritance": false
      }
    }
  },
  {
    "id": "F86",
    "label": "Mark Items Purchased",
    "moduleId": "home-shopping",
    "defaults": {
      "free": {
        "status": "limit",
        "limit": 20,
        "assumption": false,
        "inheritance": false
      },
      "paid_home": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_condo": {
        "status": "n/a"
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": true
      },
      "free_supplier": {
        "status": "limit",
        "limit": null,
        "assumption": true,
        "inheritance": false
      },
      "paid_supplier": {
        "status": "limit",
        "limit": null,
        "assumption": true,
        "inheritance": false
      }
    }
  },
  {
    "id": "F87",
    "label": "Add Pet Profile",
    "moduleId": "home-pets",
    "defaults": {
      "free": {
        "status": "limit",
        "limit": 1,
        "assumption": false,
        "inheritance": false
      },
      "paid_home": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_condo": {
        "status": "n/a"
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": true
      },
      "free_supplier": {
        "status": "limit",
        "limit": null,
        "assumption": true,
        "inheritance": false
      },
      "paid_supplier": {
        "status": "limit",
        "limit": null,
        "assumption": true,
        "inheritance": false
      }
    }
  },
  {
    "id": "F88",
    "label": "View Pet Records",
    "moduleId": "home-pets",
    "defaults": {
      "free": {
        "status": "limit",
        "limit": 1,
        "assumption": false,
        "inheritance": false
      },
      "paid_home": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_condo": {
        "status": "n/a"
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": true
      },
      "free_supplier": {
        "status": "limit",
        "limit": null,
        "assumption": true,
        "inheritance": false
      },
      "paid_supplier": {
        "status": "limit",
        "limit": null,
        "assumption": true,
        "inheritance": false
      }
    }
  },
  {
    "id": "F89",
    "label": "Add/Manage Vehicle",
    "moduleId": "home-vehicles",
    "defaults": {
      "free": {
        "status": "limit",
        "limit": 1,
        "assumption": false,
        "inheritance": false
      },
      "paid_home": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_condo": {
        "status": "n/a"
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": true
      },
      "free_supplier": {
        "status": "limit",
        "limit": null,
        "assumption": true,
        "inheritance": false
      },
      "paid_supplier": {
        "status": "limit",
        "limit": null,
        "assumption": true,
        "inheritance": false
      }
    }
  },
  {
    "id": "F90",
    "label": "Vehicle Maintenance Reminders",
    "moduleId": "home-vehicles",
    "defaults": {
      "free": {
        "status": "limit",
        "limit": 1,
        "assumption": false,
        "inheritance": false
      },
      "paid_home": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_condo": {
        "status": "n/a"
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": true
      },
      "free_supplier": {
        "status": "limit",
        "limit": null,
        "assumption": true,
        "inheritance": false
      },
      "paid_supplier": {
        "status": "limit",
        "limit": null,
        "assumption": true,
        "inheritance": false
      }
    }
  },
  {
    "id": "F91",
    "label": "Manage Budget Entries",
    "moduleId": "home-budget",
    "defaults": {
      "free": {
        "status": "limit",
        "limit": 5,
        "assumption": false,
        "inheritance": false
      },
      "paid_home": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_condo": {
        "status": "n/a"
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": true
      },
      "free_supplier": {
        "status": "limit",
        "limit": null,
        "assumption": true,
        "inheritance": false
      },
      "paid_supplier": {
        "status": "limit",
        "limit": null,
        "assumption": true,
        "inheritance": false
      }
    }
  },
  {
    "id": "F92",
    "label": "Budget Goals & Alerts",
    "moduleId": "home-budget",
    "defaults": {
      "free": {
        "status": "limit",
        "limit": 5,
        "assumption": false,
        "inheritance": false
      },
      "paid_home": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_condo": {
        "status": "n/a"
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": true
      },
      "free_supplier": {
        "status": "limit",
        "limit": null,
        "assumption": true,
        "inheritance": false
      },
      "paid_supplier": {
        "status": "limit",
        "limit": null,
        "assumption": true,
        "inheritance": false
      }
    }
  },
  {
    "id": "F93",
    "label": "View Supplier Directory",
    "moduleId": "supplier",
    "defaults": {
      "free": {
        "status": "included",
        "assumption": true,
        "inheritance": false
      },
      "paid_home": {
        "status": "included",
        "assumption": true,
        "inheritance": false
      },
      "free_condo": {
        "status": "included",
        "assumption": true,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": true,
        "inheritance": false
      },
      "free_supplier": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_supplier": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      }
    }
  },
  {
    "id": "F94",
    "label": "Supplier Registration / Profile",
    "moduleId": "supplier",
    "defaults": {
      "free": {
        "status": "n/a"
      },
      "paid_home": {
        "status": "n/a"
      },
      "free_condo": {
        "status": "n/a"
      },
      "paid_condo": {
        "status": "n/a"
      },
      "free_supplier": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_supplier": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      }
    }
  },
  {
    "id": "F95",
    "label": "List Services & Pricing",
    "moduleId": "supplier",
    "defaults": {
      "free": {
        "status": "n/a"
      },
      "paid_home": {
        "status": "n/a"
      },
      "free_condo": {
        "status": "n/a"
      },
      "paid_condo": {
        "status": "n/a"
      },
      "free_supplier": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_supplier": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      }
    }
  },
  {
    "id": "F96",
    "label": "Request Service",
    "moduleId": "supplier",
    "defaults": {
      "free": {
        "status": "included",
        "assumption": true,
        "inheritance": false
      },
      "paid_home": {
        "status": "included",
        "assumption": true,
        "inheritance": false
      },
      "free_condo": {
        "status": "included",
        "assumption": true,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": true,
        "inheritance": false
      },
      "free_supplier": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_supplier": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      }
    }
  },
  {
    "id": "F97",
    "label": "Manage Service Requests (Provider)",
    "moduleId": "supplier",
    "defaults": {
      "free": {
        "status": "n/a"
      },
      "paid_home": {
        "status": "n/a"
      },
      "free_condo": {
        "status": "n/a"
      },
      "paid_condo": {
        "status": "n/a"
      },
      "free_supplier": {
        "status": "limit",
        "limit": null,
        "assumption": false,
        "inheritance": false
      },
      "paid_supplier": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      }
    }
  },
  {
    "id": "F98",
    "label": "Ratings & Reviews",
    "moduleId": "supplier",
    "defaults": {
      "free": {
        "status": "included",
        "assumption": true,
        "inheritance": false
      },
      "paid_home": {
        "status": "included",
        "assumption": true,
        "inheritance": false
      },
      "free_condo": {
        "status": "included",
        "assumption": true,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": true,
        "inheritance": false
      },
      "free_supplier": {
        "status": "limit",
        "limit": null,
        "assumption": true,
        "inheritance": false
      },
      "paid_supplier": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      }
    }
  },
  {
    "id": "F99",
    "label": "Provider Payments",
    "moduleId": "supplier",
    "defaults": {
      "free": {
        "status": "n/a"
      },
      "paid_home": {
        "status": "n/a"
      },
      "free_condo": {
        "status": "n/a"
      },
      "paid_condo": {
        "status": "n/a"
      },
      "free_supplier": {
        "status": "excluded",
        "assumption": true,
        "inheritance": false
      },
      "paid_supplier": {
        "status": "included",
        "assumption": true,
        "inheritance": false
      }
    }
  },
  {
    "id": "F100",
    "label": "Edit Own Profile",
    "moduleId": "profile",
    "defaults": {
      "free": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_home": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_supplier": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      }
    }
  },
  {
    "id": "F101",
    "label": "Security (Password / 2FA)",
    "moduleId": "profile",
    "defaults": {
      "free": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_home": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_supplier": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      }
    }
  },
  {
    "id": "F102",
    "label": "Notification Preferences",
    "moduleId": "profile",
    "defaults": {
      "free": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_home": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_supplier": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      }
    }
  },
  {
    "id": "F103",
    "label": "Manage Family Members",
    "moduleId": "profile",
    "defaults": {
      "free": {
        "status": "excluded",
        "assumption": true,
        "inheritance": false
      },
      "paid_home": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_condo": {
        "status": "excluded",
        "assumption": true,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": true
      },
      "free_supplier": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_supplier": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      }
    }
  },
  {
    "id": "F104",
    "label": "Configuración del sistema",
    "moduleId": "profile",
    "defaults": {
      "free": {
        "status": "n/a"
      },
      "paid_home": {
        "status": "n/a"
      },
      "free_condo": {
        "status": "limit",
        "limit": null,
        "assumption": true,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_supplier": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      }
    }
  },
  {
    "id": "F105",
    "label": "View/Edit Condo Information",
    "moduleId": "condo-info",
    "defaults": {
      "free": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_home": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_supplier": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      }
    }
  },
  {
    "id": "F106",
    "label": "Reglamentos (Regulations)",
    "moduleId": "condo-info",
    "defaults": {
      "free": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_home": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_supplier": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      }
    }
  },
  {
    "id": "F107",
    "label": "Security Companies / Guards / Casetas",
    "moduleId": "condo-info",
    "defaults": {
      "free": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_home": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "free_supplier": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      },
      "paid_supplier": {
        "status": "included",
        "assumption": false,
        "inheritance": false
      }
    }
  },
  {
    "id": "F108",
    "label": "Chat Vecinal (Neighborhood Chat)",
    "moduleId": "communication",
    "defaults": {
      "free": {
        "status": "included",
        "assumption": true,
        "inheritance": false
      },
      "paid_home": {
        "status": "included",
        "assumption": true,
        "inheritance": false
      },
      "free_condo": {
        "status": "included",
        "assumption": true,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": true,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F109",
    "label": "Directorio de Residentes",
    "moduleId": "communication",
    "defaults": {
      "free": {
        "status": "included",
        "assumption": true,
        "inheritance": false
      },
      "paid_home": {
        "status": "included",
        "assumption": true,
        "inheritance": false
      },
      "free_condo": {
        "status": "included",
        "assumption": true,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": true,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F110",
    "label": "Mensajes Directos",
    "moduleId": "communication",
    "defaults": {
      "free": {
        "status": "included",
        "assumption": true,
        "inheritance": false
      },
      "paid_home": {
        "status": "included",
        "assumption": true,
        "inheritance": false
      },
      "free_condo": {
        "status": "included",
        "assumption": true,
        "inheritance": false
      },
      "paid_condo": {
        "status": "included",
        "assumption": true,
        "inheritance": false
      },
      "free_supplier": {
        "status": "n/a"
      },
      "paid_supplier": {
        "status": "n/a"
      }
    }
  },
  {
    "id": "F130",
    "label": "Rentas (Rental Management)",
    "moduleId": "rentals",
    "defaults": {
      "free": { "status": "included", "assumption": true, "inheritance": false },
      "paid_home": { "status": "included", "assumption": true, "inheritance": false },
      "free_condo": { "status": "n/a" },
      "paid_condo": { "status": "n/a" },
      "free_supplier": { "status": "n/a" },
      "paid_supplier": { "status": "n/a" }
    }
  },
  {
    "id": "F131",
    "label": "Rotación (Tenant Turnover)",
    "moduleId": "turnover",
    "defaults": {
      "free": { "status": "included", "assumption": true, "inheritance": false },
      "paid_home": { "status": "included", "assumption": true, "inheritance": false },
      "free_condo": { "status": "n/a" },
      "paid_condo": { "status": "n/a" },
      "free_supplier": { "status": "n/a" },
      "paid_supplier": { "status": "n/a" }
    }
  }
];
export const AUDIT_MODULES: AuditModule[] = [
  {
    "title": "Condo Management (Super Admin) — F1–F8",
    "id": "platform-admin",
    "functions": [
      {
        "id": "F1",
        "label": "Create New Condo",
        "moduleId": "platform-admin",
        "defaults": {
          "free": {
            "status": "n/a"
          },
          "paid_home": {
            "status": "n/a"
          },
          "free_condo": {
            "status": "n/a"
          },
          "paid_condo": {
            "status": "n/a"
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      },
      {
        "id": "F2",
        "label": "Edit Condo Settings",
        "moduleId": "platform-admin",
        "defaults": {
          "free": {
            "status": "n/a"
          },
          "paid_home": {
            "status": "n/a"
          },
          "free_condo": {
            "status": "n/a"
          },
          "paid_condo": {
            "status": "n/a"
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      },
      {
        "id": "F3",
        "label": "Delete/Deactivate Condo",
        "moduleId": "platform-admin",
        "defaults": {
          "free": {
            "status": "n/a"
          },
          "paid_home": {
            "status": "n/a"
          },
          "free_condo": {
            "status": "n/a"
          },
          "paid_condo": {
            "status": "n/a"
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      },
      {
        "id": "F4",
        "label": "View All Condos",
        "moduleId": "platform-admin",
        "defaults": {
          "free": {
            "status": "n/a"
          },
          "paid_home": {
            "status": "n/a"
          },
          "free_condo": {
            "status": "n/a"
          },
          "paid_condo": {
            "status": "n/a"
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      },
      {
        "id": "F5",
        "label": "Assign Admin to Condo",
        "moduleId": "platform-admin",
        "defaults": {
          "free": {
            "status": "n/a"
          },
          "paid_home": {
            "status": "n/a"
          },
          "free_condo": {
            "status": "n/a"
          },
          "paid_condo": {
            "status": "n/a"
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      },
      {
        "id": "F6",
        "label": "Set Condo Pricing Plan",
        "moduleId": "platform-admin",
        "defaults": {
          "free": {
            "status": "n/a"
          },
          "paid_home": {
            "status": "n/a"
          },
          "free_condo": {
            "status": "n/a"
          },
          "paid_condo": {
            "status": "n/a"
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      },
      {
        "id": "F7",
        "label": "View Global Analytics",
        "moduleId": "platform-admin",
        "defaults": {
          "free": {
            "status": "n/a"
          },
          "paid_home": {
            "status": "n/a"
          },
          "free_condo": {
            "status": "n/a"
          },
          "paid_condo": {
            "status": "n/a"
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      },
      {
        "id": "F8",
        "label": "Platform User Management",
        "moduleId": "platform-admin",
        "defaults": {
          "free": {
            "status": "n/a"
          },
          "paid_home": {
            "status": "n/a"
          },
          "free_condo": {
            "status": "n/a"
          },
          "paid_condo": {
            "status": "n/a"
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      }
    ]
  },
  {
    "title": "Dashboard & Analytics — F9–F10",
    "id": "dashboard",
    "functions": [
      {
        "id": "F9",
        "label": "Dashboard Principal",
        "moduleId": "dashboard",
        "defaults": {
          "free": {
            "status": "n/a"
          },
          "paid_home": {
            "status": "n/a"
          },
          "free_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      },
      {
        "id": "F10",
        "label": "View Charts/Analytics (Condo)",
        "moduleId": "dashboard",
        "defaults": {
          "free": {
            "status": "n/a"
          },
          "paid_home": {
            "status": "n/a"
          },
          "free_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      }
    ]
  },
  {
    "title": "Gestión de Residentes — F11–F19",
    "id": "residents",
    "functions": [
      {
        "id": "F11",
        "label": "Create Resident Account",
        "moduleId": "residents",
        "defaults": {
          "free": {
            "status": "n/a"
          },
          "paid_home": {
            "status": "n/a"
          },
          "free_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      },
      {
        "id": "F12",
        "label": "Create Propietario Account",
        "moduleId": "residents",
        "defaults": {
          "free": {
            "status": "n/a"
          },
          "paid_home": {
            "status": "n/a"
          },
          "free_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      },
      {
        "id": "F13",
        "label": "Create Inquilino Account",
        "moduleId": "residents",
        "defaults": {
          "free": {
            "status": "n/a"
          },
          "paid_home": {
            "status": "n/a"
          },
          "free_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      },
      {
        "id": "F14",
        "label": "Create Empleado Account",
        "moduleId": "residents",
        "defaults": {
          "free": {
            "status": "n/a"
          },
          "paid_home": {
            "status": "n/a"
          },
          "free_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      },
      {
        "id": "F15",
        "label": "Edit Resident Data",
        "moduleId": "residents",
        "defaults": {
          "free": {
            "status": "n/a"
          },
          "paid_home": {
            "status": "n/a"
          },
          "free_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      },
      {
        "id": "F16",
        "label": "Suspend Resident",
        "moduleId": "residents",
        "defaults": {
          "free": {
            "status": "n/a"
          },
          "paid_home": {
            "status": "n/a"
          },
          "free_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      },
      {
        "id": "F17",
        "label": "Delete Resident",
        "moduleId": "residents",
        "defaults": {
          "free": {
            "status": "n/a"
          },
          "paid_home": {
            "status": "n/a"
          },
          "free_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      },
      {
        "id": "F18",
        "label": "View Resident List",
        "moduleId": "residents",
        "defaults": {
          "free": {
            "status": "n/a"
          },
          "paid_home": {
            "status": "n/a"
          },
          "free_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      },
      {
        "id": "F19",
        "label": "Export Resident Data",
        "moduleId": "residents",
        "defaults": {
          "free": {
            "status": "n/a"
          },
          "paid_home": {
            "status": "n/a"
          },
          "free_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      }
    ]
  },
  {
    "title": "Finanzas — Estado de Cuenta — F20–F23",
    "id": "finances",
    "functions": [
      {
        "id": "F20",
        "label": "View Condo Financial Summary",
        "moduleId": "finances",
        "defaults": {
          "free": {
            "status": "included",
            "assumption": true,
            "inheritance": false
          },
          "paid_home": {
            "status": "included",
            "assumption": true,
            "inheritance": false
          },
          "free_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      },
      {
        "id": "F21",
        "label": "View Personal Account",
        "moduleId": "finances",
        "defaults": {
          "free": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_home": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      },
      {
        "id": "F22",
        "label": "View Resident Account (Admin)",
        "moduleId": "finances",
        "defaults": {
          "free": {
            "status": "n/a"
          },
          "paid_home": {
            "status": "n/a"
          },
          "free_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      },
      {
        "id": "F23",
        "label": "Monthly Close / Reports",
        "moduleId": "finances",
        "defaults": {
          "free": {
            "status": "n/a"
          },
          "paid_home": {
            "status": "n/a"
          },
          "free_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      }
    ]
  },
  {
    "title": "Finanzas — Ingresos — F24–F26",
    "id": "finances",
    "functions": [
      {
        "id": "F24",
        "label": "Add Income Entry",
        "moduleId": "finances",
        "defaults": {
          "free": {
            "status": "n/a"
          },
          "paid_home": {
            "status": "n/a"
          },
          "free_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      },
      {
        "id": "F25",
        "label": "View All Income",
        "moduleId": "finances",
        "defaults": {
          "free": {
            "status": "n/a"
          },
          "paid_home": {
            "status": "n/a"
          },
          "free_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      },
      {
        "id": "F26",
        "label": "Create Income Categories",
        "moduleId": "finances",
        "defaults": {
          "free": {
            "status": "n/a"
          },
          "paid_home": {
            "status": "n/a"
          },
          "free_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      }
    ]
  },
  {
    "title": "Finanzas — Gastos — F27–F32",
    "id": "finances",
    "functions": [
      {
        "id": "F27",
        "label": "Add Expense Entry",
        "moduleId": "finances",
        "defaults": {
          "free": {
            "status": "n/a"
          },
          "paid_home": {
            "status": "n/a"
          },
          "free_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      },
      {
        "id": "F28",
        "label": "View All Expenses",
        "moduleId": "finances",
        "defaults": {
          "free": {
            "status": "n/a"
          },
          "paid_home": {
            "status": "n/a"
          },
          "free_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      },
      {
        "id": "F29",
        "label": "Create Expense Categories",
        "moduleId": "finances",
        "defaults": {
          "free": {
            "status": "n/a"
          },
          "paid_home": {
            "status": "n/a"
          },
          "free_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      },
      {
        "id": "F30",
        "label": "Upload Expense Receipt",
        "moduleId": "finances",
        "defaults": {
          "free": {
            "status": "n/a"
          },
          "paid_home": {
            "status": "n/a"
          },
          "free_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      },
      {
        "id": "F31",
        "label": "Approve Expenses (> threshold)",
        "moduleId": "finances",
        "defaults": {
          "free": {
            "status": "n/a"
          },
          "paid_home": {
            "status": "n/a"
          },
          "free_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      },
      {
        "id": "F32",
        "label": "View Pending Approvals",
        "moduleId": "finances",
        "defaults": {
          "free": {
            "status": "n/a"
          },
          "paid_home": {
            "status": "n/a"
          },
          "free_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      }
    ]
  },
  {
    "title": "Finanzas — Cotizaciones — F33–F36",
    "id": "quotes",
    "functions": [
      {
        "id": "F33",
        "label": "Create Project",
        "moduleId": "quotes",
        "defaults": {
          "free": {
            "status": "n/a"
          },
          "paid_home": {
            "status": "n/a"
          },
          "free_condo": {
            "status": "excluded",
            "assumption": true,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": true,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      },
      {
        "id": "F34",
        "label": "Add Quote (min 3)",
        "moduleId": "quotes",
        "defaults": {
          "free": {
            "status": "n/a"
          },
          "paid_home": {
            "status": "n/a"
          },
          "free_condo": {
            "status": "excluded",
            "assumption": true,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": true,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      },
      {
        "id": "F35",
        "label": "Approve Project / Quote",
        "moduleId": "quotes",
        "defaults": {
          "free": {
            "status": "n/a"
          },
          "paid_home": {
            "status": "n/a"
          },
          "free_condo": {
            "status": "excluded",
            "assumption": true,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": true,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      },
      {
        "id": "F36",
        "label": "View Project Status",
        "moduleId": "quotes",
        "defaults": {
          "free": {
            "status": "n/a"
          },
          "paid_home": {
            "status": "n/a"
          },
          "free_condo": {
            "status": "excluded",
            "assumption": true,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": true,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      }
    ]
  },
  {
    "title": "Finanzas — Pagos — F37–F40",
    "id": "payments",
    "functions": [
      {
        "id": "F37",
        "label": "Make Payment (Resident)",
        "moduleId": "payments",
        "defaults": {
          "free": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_home": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      },
      {
        "id": "F38",
        "label": "View Payment History",
        "moduleId": "payments",
        "defaults": {
          "free": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_home": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      },
      {
        "id": "F39",
        "label": "Record Manual Payment",
        "moduleId": "payments",
        "defaults": {
          "free": {
            "status": "n/a"
          },
          "paid_home": {
            "status": "n/a"
          },
          "free_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      },
      {
        "id": "F40",
        "label": "Generate Payment Reports",
        "moduleId": "payments",
        "defaults": {
          "free": {
            "status": "n/a"
          },
          "paid_home": {
            "status": "n/a"
          },
          "free_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      }
    ]
  },
  {
    "title": "Morosos — F41–F43",
    "id": "morosos",
    "functions": [
      {
        "id": "F41",
        "label": "View Morosos List",
        "moduleId": "morosos",
        "defaults": {
          "free": {
            "status": "n/a"
          },
          "paid_home": {
            "status": "n/a"
          },
          "free_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      },
      {
        "id": "F42",
        "label": "Configure Morosidad Rules",
        "moduleId": "morosos",
        "defaults": {
          "free": {
            "status": "n/a"
          },
          "paid_home": {
            "status": "n/a"
          },
          "free_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      },
      {
        "id": "F43",
        "label": "Send Moroso Notifications",
        "moduleId": "morosos",
        "defaults": {
          "free": {
            "status": "n/a"
          },
          "paid_home": {
            "status": "n/a"
          },
          "free_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      }
    ]
  },
  {
    "title": "Amenidades — F44–F49",
    "id": "amenities",
    "functions": [
      {
        "id": "F44",
        "label": "Create/Edit Amenities",
        "moduleId": "amenities",
        "defaults": {
          "free": {
            "status": "n/a"
          },
          "paid_home": {
            "status": "n/a"
          },
          "free_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      },
      {
        "id": "F45",
        "label": "Set Amenity Pricing",
        "moduleId": "amenities",
        "defaults": {
          "free": {
            "status": "n/a"
          },
          "paid_home": {
            "status": "n/a"
          },
          "free_condo": {
            "status": "included",
            "assumption": true,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      },
      {
        "id": "F46",
        "label": "Create Reservation",
        "moduleId": "amenities",
        "defaults": {
          "free": {
            "status": "excluded",
            "assumption": false,
            "inheritance": false
          },
          "paid_home": {
            "status": "excluded",
            "assumption": false,
            "inheritance": false
          },
          "free_condo": {
            "status": "excluded",
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      },
      {
        "id": "F47",
        "label": "Approve Reservation",
        "moduleId": "amenities",
        "defaults": {
          "free": {
            "status": "n/a"
          },
          "paid_home": {
            "status": "n/a"
          },
          "free_condo": {
            "status": "excluded",
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      },
      {
        "id": "F48",
        "label": "View All Reservations",
        "moduleId": "amenities",
        "defaults": {
          "free": {
            "status": "n/a"
          },
          "paid_home": {
            "status": "n/a"
          },
          "free_condo": {
            "status": "excluded",
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      },
      {
        "id": "F49",
        "label": "Cancel Reservation",
        "moduleId": "amenities",
        "defaults": {
          "free": {
            "status": "excluded",
            "assumption": false,
            "inheritance": false
          },
          "paid_home": {
            "status": "excluded",
            "assumption": false,
            "inheritance": false
          },
          "free_condo": {
            "status": "excluded",
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      }
    ]
  },
  {
    "title": "Calendario — F50–F54",
    "id": "calendar",
    "functions": [
      {
        "id": "F50",
        "label": "Create Event",
        "moduleId": "calendar",
        "defaults": {
          "free": {
            "status": "limit",
            "limit": 5,
            "assumption": false,
            "inheritance": false
          },
          "paid_home": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_condo": {
            "status": "limit",
            "limit": 5,
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      },
      {
        "id": "F51",
        "label": "Edit Event",
        "moduleId": "calendar",
        "defaults": {
          "free": {
            "status": "limit",
            "limit": 5,
            "assumption": false,
            "inheritance": false
          },
          "paid_home": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_condo": {
            "status": "limit",
            "limit": 5,
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      },
      {
        "id": "F52",
        "label": "Delete Event",
        "moduleId": "calendar",
        "defaults": {
          "free": {
            "status": "limit",
            "limit": 5,
            "assumption": false,
            "inheritance": false
          },
          "paid_home": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_condo": {
            "status": "limit",
            "limit": 5,
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      },
      {
        "id": "F53",
        "label": "View Events",
        "moduleId": "calendar",
        "defaults": {
          "free": {
            "status": "limit",
            "limit": 5,
            "assumption": false,
            "inheritance": false
          },
          "paid_home": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_condo": {
            "status": "limit",
            "limit": 5,
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      },
      {
        "id": "F54",
        "label": "RSVP to Event",
        "moduleId": "calendar",
        "defaults": {
          "free": {
            "status": "limit",
            "limit": 5,
            "assumption": false,
            "inheritance": false
          },
          "paid_home": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_condo": {
            "status": "limit",
            "limit": 5,
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      }
    ]
  },
  {
    "title": "Quejas y Sugerencias — F55–F58",
    "id": "complaints",
    "functions": [
      {
        "id": "F55",
        "label": "Submit Complaint",
        "moduleId": "complaints",
        "defaults": {
          "free": {
            "status": "limit",
            "limit": 5,
            "assumption": false,
            "inheritance": false
          },
          "paid_home": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_condo": {
            "status": "limit",
            "limit": 5,
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      },
      {
        "id": "F56",
        "label": "View All Complaints",
        "moduleId": "complaints",
        "defaults": {
          "free": {
            "status": "limit",
            "limit": 5,
            "assumption": false,
            "inheritance": false
          },
          "paid_home": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_condo": {
            "status": "limit",
            "limit": 5,
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      },
      {
        "id": "F57",
        "label": "Respond to Complaint",
        "moduleId": "complaints",
        "defaults": {
          "free": {
            "status": "limit",
            "limit": 5,
            "assumption": false,
            "inheritance": false
          },
          "paid_home": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_condo": {
            "status": "limit",
            "limit": 5,
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      },
      {
        "id": "F58",
        "label": "Marcar como resuelta",
        "moduleId": "complaints",
        "defaults": {
          "free": {
            "status": "limit",
            "limit": 5,
            "assumption": false,
            "inheritance": false
          },
          "paid_home": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_condo": {
            "status": "limit",
            "limit": 5,
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      }
    ]
  },
  {
    "title": "Anuncios — F59–F62",
    "id": "announcements",
    "functions": [
      {
        "id": "F59",
        "label": "Create Announcement",
        "moduleId": "announcements",
        "defaults": {
          "free": {
            "status": "n/a"
          },
          "paid_home": {
            "status": "n/a"
          },
          "free_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      },
      {
        "id": "F60",
        "label": "Edit Announcement",
        "moduleId": "announcements",
        "defaults": {
          "free": {
            "status": "n/a"
          },
          "paid_home": {
            "status": "n/a"
          },
          "free_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      },
      {
        "id": "F61",
        "label": "Delete Announcement",
        "moduleId": "announcements",
        "defaults": {
          "free": {
            "status": "n/a"
          },
          "paid_home": {
            "status": "n/a"
          },
          "free_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      },
      {
        "id": "F62",
        "label": "View Announcements",
        "moduleId": "announcements",
        "defaults": {
          "free": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_home": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      }
    ]
  },
  {
    "title": "Votaciones — F63–F65",
    "id": "voting",
    "functions": [
      {
        "id": "F63",
        "label": "Create Vote/Poll",
        "moduleId": "voting",
        "defaults": {
          "free": {
            "status": "included",
            "assumption": true,
            "inheritance": false
          },
          "paid_home": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      },
      {
        "id": "F64",
        "label": "Cast Vote",
        "moduleId": "voting",
        "defaults": {
          "free": {
            "status": "included",
            "assumption": true,
            "inheritance": false
          },
          "paid_home": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      },
      {
        "id": "F65",
        "label": "View Vote Results",
        "moduleId": "voting",
        "defaults": {
          "free": {
            "status": "included",
            "assumption": true,
            "inheritance": false
          },
          "paid_home": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      }
    ]
  },
  {
    "title": "QR y Acceso — F66–F68",
    "id": "qr-access",
    "functions": [
      {
        "id": "F66",
        "label": "View Personal QR",
        "moduleId": "qr-access",
        "defaults": {
          "free": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_home": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      },
      {
        "id": "F67",
        "label": "Generate Guest QR",
        "moduleId": "qr-access",
        "defaults": {
          "free": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_home": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      },
      {
        "id": "F68",
        "label": "Verify QR (Scan)",
        "moduleId": "qr-access",
        "defaults": {
          "free": {
            "status": "n/a"
          },
          "paid_home": {
            "status": "n/a"
          },
          "free_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      }
    ]
  },
  {
    "title": "Botón de Pánico — F69–F71",
    "id": "panic",
    "functions": [
      {
        "id": "F69",
        "label": "Trigger Panic Button",
        "moduleId": "panic",
        "defaults": {
          "free": {
            "status": "excluded",
            "assumption": false,
            "inheritance": false
          },
          "paid_home": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_condo": {
            "status": "excluded",
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      },
      {
        "id": "F70",
        "label": "View Panic Alerts",
        "moduleId": "panic",
        "defaults": {
          "free": {
            "status": "n/a"
          },
          "paid_home": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_condo": {
            "status": "excluded",
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      },
      {
        "id": "F71",
        "label": "Respond to Alert",
        "moduleId": "panic",
        "defaults": {
          "free": {
            "status": "n/a"
          },
          "paid_home": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_condo": {
            "status": "excluded",
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      }
    ]
  },
  {
    "title": "Seguridad — Visitantes — F72–F75",
    "id": "security",
    "functions": [
      {
        "id": "F72",
        "label": "Registro de Visitas (Visitor Log module)",
        "moduleId": "security",
        "defaults": {
          "free": {
            "status": "n/a"
          },
          "paid_home": {
            "status": "n/a"
          },
          "free_condo": {
            "status": "excluded",
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      },
      {
        "id": "F73",
        "label": "Register Visitor Entry",
        "moduleId": "security",
        "defaults": {
          "free": {
            "status": "n/a"
          },
          "paid_home": {
            "status": "n/a"
          },
          "free_condo": {
            "status": "excluded",
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      },
      {
        "id": "F74",
        "label": "Register Visitor Exit",
        "moduleId": "security",
        "defaults": {
          "free": {
            "status": "n/a"
          },
          "paid_home": {
            "status": "n/a"
          },
          "free_condo": {
            "status": "excluded",
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      },
      {
        "id": "F75",
        "label": "View Visitor Log",
        "moduleId": "security",
        "defaults": {
          "free": {
            "status": "n/a"
          },
          "paid_home": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_condo": {
            "status": "excluded",
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      }
    ]
  },
  {
    "title": "Seguridad — Emergencias — F76–F77",
    "id": "security",
    "functions": [
      {
        "id": "F76",
        "label": "View Emergency Contacts",
        "moduleId": "security",
        "defaults": {
          "free": {
            "status": "included",
            "assumption": true,
            "inheritance": false
          },
          "paid_home": {
            "status": "included",
            "assumption": true,
            "inheritance": false
          },
          "free_condo": {
            "status": "included",
            "assumption": true,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": true,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      },
      {
        "id": "F77",
        "label": "Call Emergency Number",
        "moduleId": "security",
        "defaults": {
          "free": {
            "status": "included",
            "assumption": true,
            "inheritance": false
          },
          "paid_home": {
            "status": "included",
            "assumption": true,
            "inheritance": false
          },
          "free_condo": {
            "status": "included",
            "assumption": true,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": true,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      }
    ]
  },
  {
    "title": "Seguridad — Avisos de Viaje — F78–F79",
    "id": "travel",
    "functions": [
      {
        "id": "F78",
        "label": "Aviso de Viaje (Create)",
        "moduleId": "travel",
        "defaults": {
          "free": {
            "status": "excluded",
            "assumption": false,
            "inheritance": false
          },
          "paid_home": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_condo": {
            "status": "excluded",
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      },
      {
        "id": "F79",
        "label": "Aviso de Viaje (View)",
        "moduleId": "travel",
        "defaults": {
          "free": {
            "status": "excluded",
            "assumption": false,
            "inheritance": false
          },
          "paid_home": {
            "status": "included",
            "assumption": true,
            "inheritance": false
          },
          "free_condo": {
            "status": "excluded",
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      }
    ]
  },
  {
    "title": "Home+ — Tareas — F80–F83",
    "id": "home-tasks",
    "functions": [
      {
        "id": "F80",
        "label": "Create Task",
        "moduleId": "home-tasks",
        "defaults": {
          "free": {
            "status": "limit",
            "limit": 5,
            "assumption": false,
            "inheritance": false
          },
          "paid_home": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_condo": {
            "status": "n/a"
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": true
          },
          "free_supplier": {
            "status": "limit",
            "limit": null,
            "assumption": true,
            "inheritance": false
          },
          "paid_supplier": {
            "status": "limit",
            "limit": null,
            "assumption": true,
            "inheritance": false
          }
        }
      },
      {
        "id": "F81",
        "label": "Assign Task",
        "moduleId": "home-tasks",
        "defaults": {
          "free": {
            "status": "limit",
            "limit": 5,
            "assumption": false,
            "inheritance": false
          },
          "paid_home": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_condo": {
            "status": "n/a"
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": true
          },
          "free_supplier": {
            "status": "limit",
            "limit": null,
            "assumption": true,
            "inheritance": false
          },
          "paid_supplier": {
            "status": "limit",
            "limit": null,
            "assumption": true,
            "inheritance": false
          }
        }
      },
      {
        "id": "F82",
        "label": "Complete Task",
        "moduleId": "home-tasks",
        "defaults": {
          "free": {
            "status": "limit",
            "limit": 5,
            "assumption": false,
            "inheritance": false
          },
          "paid_home": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_condo": {
            "status": "n/a"
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": true
          },
          "free_supplier": {
            "status": "limit",
            "limit": null,
            "assumption": true,
            "inheritance": false
          },
          "paid_supplier": {
            "status": "limit",
            "limit": null,
            "assumption": true,
            "inheritance": false
          }
        }
      },
      {
        "id": "F83",
        "label": "View Task List",
        "moduleId": "home-tasks",
        "defaults": {
          "free": {
            "status": "limit",
            "limit": 5,
            "assumption": false,
            "inheritance": false
          },
          "paid_home": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_condo": {
            "status": "n/a"
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": true
          },
          "free_supplier": {
            "status": "limit",
            "limit": null,
            "assumption": true,
            "inheritance": false
          },
          "paid_supplier": {
            "status": "limit",
            "limit": null,
            "assumption": true,
            "inheritance": false
          }
        }
      }
    ]
  },
  {
    "title": "Home+ — Lista de Compras — F84–F86",
    "id": "home-shopping",
    "functions": [
      {
        "id": "F84",
        "label": "Create Shopping List / Item",
        "moduleId": "home-shopping",
        "defaults": {
          "free": {
            "status": "limit",
            "limit": 20,
            "assumption": false,
            "inheritance": false
          },
          "paid_home": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_condo": {
            "status": "n/a"
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": true
          },
          "free_supplier": {
            "status": "limit",
            "limit": null,
            "assumption": true,
            "inheritance": false
          },
          "paid_supplier": {
            "status": "limit",
            "limit": null,
            "assumption": true,
            "inheritance": false
          }
        }
      },
      {
        "id": "F85",
        "label": "Share Shopping List",
        "moduleId": "home-shopping",
        "defaults": {
          "free": {
            "status": "limit",
            "limit": 20,
            "assumption": false,
            "inheritance": false
          },
          "paid_home": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_condo": {
            "status": "n/a"
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": true
          },
          "free_supplier": {
            "status": "limit",
            "limit": null,
            "assumption": true,
            "inheritance": false
          },
          "paid_supplier": {
            "status": "limit",
            "limit": null,
            "assumption": true,
            "inheritance": false
          }
        }
      },
      {
        "id": "F86",
        "label": "Mark Items Purchased",
        "moduleId": "home-shopping",
        "defaults": {
          "free": {
            "status": "limit",
            "limit": 20,
            "assumption": false,
            "inheritance": false
          },
          "paid_home": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_condo": {
            "status": "n/a"
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": true
          },
          "free_supplier": {
            "status": "limit",
            "limit": null,
            "assumption": true,
            "inheritance": false
          },
          "paid_supplier": {
            "status": "limit",
            "limit": null,
            "assumption": true,
            "inheritance": false
          }
        }
      }
    ]
  },
  {
    "title": "Home+ — Mascotas — F87–F88",
    "id": "home-pets",
    "functions": [
      {
        "id": "F87",
        "label": "Add Pet Profile",
        "moduleId": "home-pets",
        "defaults": {
          "free": {
            "status": "limit",
            "limit": 1,
            "assumption": false,
            "inheritance": false
          },
          "paid_home": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_condo": {
            "status": "n/a"
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": true
          },
          "free_supplier": {
            "status": "limit",
            "limit": null,
            "assumption": true,
            "inheritance": false
          },
          "paid_supplier": {
            "status": "limit",
            "limit": null,
            "assumption": true,
            "inheritance": false
          }
        }
      },
      {
        "id": "F88",
        "label": "View Pet Records",
        "moduleId": "home-pets",
        "defaults": {
          "free": {
            "status": "limit",
            "limit": 1,
            "assumption": false,
            "inheritance": false
          },
          "paid_home": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_condo": {
            "status": "n/a"
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": true
          },
          "free_supplier": {
            "status": "limit",
            "limit": null,
            "assumption": true,
            "inheritance": false
          },
          "paid_supplier": {
            "status": "limit",
            "limit": null,
            "assumption": true,
            "inheritance": false
          }
        }
      }
    ]
  },
  {
    "title": "Home+ — Vehículos — F89–F90",
    "id": "home-vehicles",
    "functions": [
      {
        "id": "F89",
        "label": "Add/Manage Vehicle",
        "moduleId": "home-vehicles",
        "defaults": {
          "free": {
            "status": "limit",
            "limit": 1,
            "assumption": false,
            "inheritance": false
          },
          "paid_home": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_condo": {
            "status": "n/a"
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": true
          },
          "free_supplier": {
            "status": "limit",
            "limit": null,
            "assumption": true,
            "inheritance": false
          },
          "paid_supplier": {
            "status": "limit",
            "limit": null,
            "assumption": true,
            "inheritance": false
          }
        }
      },
      {
        "id": "F90",
        "label": "Vehicle Maintenance Reminders",
        "moduleId": "home-vehicles",
        "defaults": {
          "free": {
            "status": "limit",
            "limit": 1,
            "assumption": false,
            "inheritance": false
          },
          "paid_home": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_condo": {
            "status": "n/a"
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": true
          },
          "free_supplier": {
            "status": "limit",
            "limit": null,
            "assumption": true,
            "inheritance": false
          },
          "paid_supplier": {
            "status": "limit",
            "limit": null,
            "assumption": true,
            "inheritance": false
          }
        }
      }
    ]
  },
  {
    "title": "Home+ — Presupuesto — F91–F92",
    "id": "home-budget",
    "functions": [
      {
        "id": "F91",
        "label": "Manage Budget Entries",
        "moduleId": "home-budget",
        "defaults": {
          "free": {
            "status": "limit",
            "limit": 5,
            "assumption": false,
            "inheritance": false
          },
          "paid_home": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_condo": {
            "status": "n/a"
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": true
          },
          "free_supplier": {
            "status": "limit",
            "limit": null,
            "assumption": true,
            "inheritance": false
          },
          "paid_supplier": {
            "status": "limit",
            "limit": null,
            "assumption": true,
            "inheritance": false
          }
        }
      },
      {
        "id": "F92",
        "label": "Budget Goals & Alerts",
        "moduleId": "home-budget",
        "defaults": {
          "free": {
            "status": "limit",
            "limit": 5,
            "assumption": false,
            "inheritance": false
          },
          "paid_home": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_condo": {
            "status": "n/a"
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": true
          },
          "free_supplier": {
            "status": "limit",
            "limit": null,
            "assumption": true,
            "inheritance": false
          },
          "paid_supplier": {
            "status": "limit",
            "limit": null,
            "assumption": true,
            "inheritance": false
          }
        }
      }
    ]
  },
  {
    "title": "Supplier Marketplace — F93–F99",
    "id": "supplier",
    "functions": [
      {
        "id": "F93",
        "label": "View Supplier Directory",
        "moduleId": "supplier",
        "defaults": {
          "free": {
            "status": "included",
            "assumption": true,
            "inheritance": false
          },
          "paid_home": {
            "status": "included",
            "assumption": true,
            "inheritance": false
          },
          "free_condo": {
            "status": "included",
            "assumption": true,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": true,
            "inheritance": false
          },
          "free_supplier": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_supplier": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          }
        }
      },
      {
        "id": "F94",
        "label": "Supplier Registration / Profile",
        "moduleId": "supplier",
        "defaults": {
          "free": {
            "status": "n/a"
          },
          "paid_home": {
            "status": "n/a"
          },
          "free_condo": {
            "status": "n/a"
          },
          "paid_condo": {
            "status": "n/a"
          },
          "free_supplier": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_supplier": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          }
        }
      },
      {
        "id": "F95",
        "label": "List Services & Pricing",
        "moduleId": "supplier",
        "defaults": {
          "free": {
            "status": "n/a"
          },
          "paid_home": {
            "status": "n/a"
          },
          "free_condo": {
            "status": "n/a"
          },
          "paid_condo": {
            "status": "n/a"
          },
          "free_supplier": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_supplier": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          }
        }
      },
      {
        "id": "F96",
        "label": "Request Service",
        "moduleId": "supplier",
        "defaults": {
          "free": {
            "status": "included",
            "assumption": true,
            "inheritance": false
          },
          "paid_home": {
            "status": "included",
            "assumption": true,
            "inheritance": false
          },
          "free_condo": {
            "status": "included",
            "assumption": true,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": true,
            "inheritance": false
          },
          "free_supplier": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_supplier": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          }
        }
      },
      {
        "id": "F97",
        "label": "Manage Service Requests (Provider)",
        "moduleId": "supplier",
        "defaults": {
          "free": {
            "status": "n/a"
          },
          "paid_home": {
            "status": "n/a"
          },
          "free_condo": {
            "status": "n/a"
          },
          "paid_condo": {
            "status": "n/a"
          },
          "free_supplier": {
            "status": "limit",
            "limit": null,
            "assumption": false,
            "inheritance": false
          },
          "paid_supplier": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          }
        }
      },
      {
        "id": "F98",
        "label": "Ratings & Reviews",
        "moduleId": "supplier",
        "defaults": {
          "free": {
            "status": "included",
            "assumption": true,
            "inheritance": false
          },
          "paid_home": {
            "status": "included",
            "assumption": true,
            "inheritance": false
          },
          "free_condo": {
            "status": "included",
            "assumption": true,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": true,
            "inheritance": false
          },
          "free_supplier": {
            "status": "limit",
            "limit": null,
            "assumption": true,
            "inheritance": false
          },
          "paid_supplier": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          }
        }
      },
      {
        "id": "F99",
        "label": "Provider Payments",
        "moduleId": "supplier",
        "defaults": {
          "free": {
            "status": "n/a"
          },
          "paid_home": {
            "status": "n/a"
          },
          "free_condo": {
            "status": "n/a"
          },
          "paid_condo": {
            "status": "n/a"
          },
          "free_supplier": {
            "status": "excluded",
            "assumption": true,
            "inheritance": false
          },
          "paid_supplier": {
            "status": "included",
            "assumption": true,
            "inheritance": false
          }
        }
      }
    ]
  },
  {
    "title": "Profile & Settings — F100–F104",
    "id": "profile",
    "functions": [
      {
        "id": "F100",
        "label": "Edit Own Profile",
        "moduleId": "profile",
        "defaults": {
          "free": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_home": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_supplier": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          }
        }
      },
      {
        "id": "F101",
        "label": "Security (Password / 2FA)",
        "moduleId": "profile",
        "defaults": {
          "free": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_home": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_supplier": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          }
        }
      },
      {
        "id": "F102",
        "label": "Notification Preferences",
        "moduleId": "profile",
        "defaults": {
          "free": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_home": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_supplier": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          }
        }
      },
      {
        "id": "F103",
        "label": "Manage Family Members",
        "moduleId": "profile",
        "defaults": {
          "free": {
            "status": "excluded",
            "assumption": true,
            "inheritance": false
          },
          "paid_home": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_condo": {
            "status": "excluded",
            "assumption": true,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": true
          },
          "free_supplier": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_supplier": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          }
        }
      },
      {
        "id": "F104",
        "label": "Configuración del sistema",
        "moduleId": "profile",
        "defaults": {
          "free": {
            "status": "n/a"
          },
          "paid_home": {
            "status": "n/a"
          },
          "free_condo": {
            "status": "limit",
            "limit": null,
            "assumption": true,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_supplier": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          }
        }
      }
    ]
  },
  {
    "title": "Información del Condominio — F105–F107",
    "id": "condo-info",
    "functions": [
      {
        "id": "F105",
        "label": "View/Edit Condo Information",
        "moduleId": "condo-info",
        "defaults": {
          "free": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_home": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_supplier": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          }
        }
      },
      {
        "id": "F106",
        "label": "Reglamentos (Regulations)",
        "moduleId": "condo-info",
        "defaults": {
          "free": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_home": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_supplier": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          }
        }
      },
      {
        "id": "F107",
        "label": "Security Companies / Guards / Casetas",
        "moduleId": "condo-info",
        "defaults": {
          "free": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_home": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "free_supplier": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          },
          "paid_supplier": {
            "status": "included",
            "assumption": false,
            "inheritance": false
          }
        }
      }
    ]
  },
  {
    "title": "Comunicación — F108–F110",
    "id": "communication",
    "functions": [
      {
        "id": "F108",
        "label": "Chat Vecinal (Neighborhood Chat)",
        "moduleId": "communication",
        "defaults": {
          "free": {
            "status": "included",
            "assumption": true,
            "inheritance": false
          },
          "paid_home": {
            "status": "included",
            "assumption": true,
            "inheritance": false
          },
          "free_condo": {
            "status": "included",
            "assumption": true,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": true,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      },
      {
        "id": "F109",
        "label": "Directorio de Residentes",
        "moduleId": "communication",
        "defaults": {
          "free": {
            "status": "included",
            "assumption": true,
            "inheritance": false
          },
          "paid_home": {
            "status": "included",
            "assumption": true,
            "inheritance": false
          },
          "free_condo": {
            "status": "included",
            "assumption": true,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": true,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      },
      {
        "id": "F110",
        "label": "Mensajes Directos",
        "moduleId": "communication",
        "defaults": {
          "free": {
            "status": "included",
            "assumption": true,
            "inheritance": false
          },
          "paid_home": {
            "status": "included",
            "assumption": true,
            "inheritance": false
          },
          "free_condo": {
            "status": "included",
            "assumption": true,
            "inheritance": false
          },
          "paid_condo": {
            "status": "included",
            "assumption": true,
            "inheritance": false
          },
          "free_supplier": {
            "status": "n/a"
          },
          "paid_supplier": {
            "status": "n/a"
          }
        }
      }
    ]
  },
  {
    "title": "Sections & Internal Address — F111–F118",
    "id": "sections",
    "functions": [
      {
        "id": "F111",
        "label": "Sections Schema & Hierarchy Model",
        "moduleId": "sections",
        "defaults": {
          "free": { "status": "n/a" },
          "paid_home": { "status": "n/a" },
          "free_condo": { "status": "n/a" },
          "paid_condo": { "status": "n/a" },
          "free_supplier": { "status": "n/a" },
          "paid_supplier": { "status": "n/a" }
        }
      },
      {
        "id": "F112",
        "label": "Section CRUD",
        "moduleId": "sections",
        "defaults": {
          "free": { "status": "n/a" },
          "paid_home": { "status": "n/a" },
          "free_condo": { "status": "n/a" },
          "paid_condo": { "status": "n/a" },
          "free_supplier": { "status": "n/a" },
          "paid_supplier": { "status": "n/a" }
        }
      },
      {
        "id": "F113",
        "label": "Section-Scoped Access",
        "moduleId": "sections",
        "defaults": {
          "free": { "status": "n/a" },
          "paid_home": { "status": "n/a" },
          "free_condo": { "status": "n/a" },
          "paid_condo": { "status": "n/a" },
          "free_supplier": { "status": "n/a" },
          "paid_supplier": { "status": "n/a" }
        }
      },
      {
        "id": "F114",
        "label": "Billing Inheritance and Coverage",
        "moduleId": "sections",
        "defaults": {
          "free": { "status": "n/a" },
          "paid_home": { "status": "n/a" },
          "free_condo": { "status": "n/a" },
          "paid_condo": { "status": "n/a" },
          "free_supplier": { "status": "n/a" },
          "paid_supplier": { "status": "n/a" }
        }
      },
      {
        "id": "F115",
        "label": "Accounting Attribution by Paying Node",
        "moduleId": "sections",
        "defaults": {
          "free": { "status": "n/a" },
          "paid_home": { "status": "n/a" },
          "free_condo": { "status": "n/a" },
          "paid_condo": { "status": "n/a" },
          "free_supplier": { "status": "n/a" },
          "paid_supplier": { "status": "n/a" }
        }
      },
      {
        "id": "F116",
        "label": "Unit Forms and Guarded Capacity",
        "moduleId": "sections",
        "defaults": {
          "free": { "status": "n/a" },
          "paid_home": { "status": "n/a" },
          "free_condo": { "status": "n/a" },
          "paid_condo": { "status": "n/a" },
          "free_supplier": { "status": "n/a" },
          "paid_supplier": { "status": "n/a" }
        }
      },
      {
        "id": "F117",
        "label": "Per-Section Reports",
        "moduleId": "sections",
        "defaults": {
          "free": { "status": "n/a" },
          "paid_home": { "status": "n/a" },
          "free_condo": { "status": "n/a" },
          "paid_condo": { "status": "n/a" },
          "free_supplier": { "status": "n/a" },
          "paid_supplier": { "status": "n/a" }
        }
      },
      {
        "id": "F118",
        "label": "Users by Section Richness",
        "moduleId": "sections",
        "defaults": {
          "free": { "status": "n/a" },
          "paid_home": { "status": "n/a" },
          "free_condo": { "status": "n/a" },
          "paid_condo": { "status": "n/a" },
          "free_supplier": { "status": "n/a" },
          "paid_supplier": { "status": "n/a" }
        }
      }
    ]
  },
  {
    "title": "Rentas & Rotación — F130–F131",
    "id": "rentals-turnover",
    "functions": [
      { "id": "F130", "label": "Rentas (Rental Management)", "moduleId": "rentals", "defaults": { "free": { "status": "included", "assumption": true, "inheritance": false }, "paid_home": { "status": "included", "assumption": true, "inheritance": false }, "free_condo": { "status": "n/a" }, "paid_condo": { "status": "n/a" }, "free_supplier": { "status": "n/a" }, "paid_supplier": { "status": "n/a" } } },
      { "id": "F131", "label": "Rotación (Tenant Turnover)", "moduleId": "turnover", "defaults": { "free": { "status": "included", "assumption": true, "inheritance": false }, "paid_home": { "status": "included", "assumption": true, "inheritance": false }, "free_condo": { "status": "n/a" }, "paid_condo": { "status": "n/a" }, "free_supplier": { "status": "n/a" }, "paid_supplier": { "status": "n/a" } } }
    ]
  },
];

// Map audit-matrix section ids -> canonical system module ids (many-to-one).
export const AUDIT_GROUP_TO_MODULE: Record<string,string> = {
  'platform-admin':'audit','dashboard':'reports-advanced','residents':'audit','finances':'expenses',
  'quotes':'quotes','payments':'expenses','morosos':'morosos','amenities':'amenities','calendar':'calendar',
  'complaints':'complaints','announcements':'announcements','voting':'voting','qr-access':'qr-access',
  'panic':'panic','security':'security','travel':'travel','home-tasks':'home-tasks','home-shopping':'home-shopping',
  'home-pets':'home-pets','home-vehicles':'home-vehicles','home-budget':'home-budget','supplier':'supplier-leads-full',
  'profile':'audit','condo-info':'regulations','communication':'announcements','misc':'audit','rentals':'rentals','turnover':'turnover'
};
